import * as blogContStyle from "./content.module.scss";
import * as yup from "yup";

import React, { useEffect, useRef, useState } from "react";

import BlogListing from "../../Stories/BlogList/BlogListing";
import Facebook from "../../Icon/Facebook";
import LinkedIn from "../../Icon/LinkedIn";
import ReactPlayer from "react-player";
import { StaticImage } from "gatsby-plugin-image";
import Twitter from "../../Icon/Twitter";
import { navigate } from "gatsby";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { ndeFormInstance } from "../../../lib/axios-client";
import BlogStickyBanner from "../BlogStickyBanner/BlogStickyBanner";
import { Loader } from '@mantine/core';
import { GoArrowRight } from "react-icons/go";

export default function BlogContent({
  title,
  description,
  date,
  updatedDate,
  author,
  authorImage,
  readTime,
  audioUrl,
  path,
  recentBlogList,
}) {

  const [apiLoading, setApiLoading] = useState(false);

  const schema = yup.object({
    name: yup
      .string()
      .required("This field is required")
      .transform((value) => value.trim()),
    email: yup
      .string()
      .required("This field is required")
      .matches(/^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/i, "Please enter a valid email"),
    phone: yup
      .string()
      .nullable()
      .matches(/^(\+\d{1,4}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, {
        message: "Please enter a valid phone number",
        excludeEmptyString: true,
      }),
    message: yup
      .string()
      .required("This field is required")
      .max(250, 'Message must be 250 characters or less')
      .transform((value) => value.trim()),
  });
  const shareURl = `https://www.designstudiouiux.com${path}`;

  const [tableContentMenu, settableContentMenu] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    reValidateMode: "onChange",
  });

  const postEl = useRef(null);

  const onSubmit = async (data) => {
    setApiLoading(true);
    const landing_page = sessionStorage.getItem("landing_page");
    
    
    try {
      await ndeFormInstance.post('/contact-form', { ...data, landing_page }, );
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "contact_form_submitted",
          ...getValues(),
        });
      }
      navigate("/thank-you");
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    } finally {
      setApiLoading(false);
    }
  };

  useEffect(() => {
    const parentEl = document.createElement("div");
    parentEl.innerHTML = description;

    const tableContentHeadline = parentEl.querySelectorAll("h2, h3");

    const toc = Object.keys(tableContentHeadline).map((key) => {
      const str = tableContentHeadline[key].innerText
        .toLowerCase()
        .replace(".", "-") // replace a dot by a dash
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by a dash
        .replace(/-+/g, "-") // collapse dashes
        .replace(/\//g, "")
        .replace(/(^\d*-)/g, "");

      tableContentHeadline[key].setAttribute("id", str);

      return tableContentHeadline[key];
    });

    const structuredtoc = toc.reduce((current, headerEl) => {
      if (headerEl.tagName.toLowerCase() === "h2") {
        headerEl.childh3 = [];
        current.push(headerEl);
      } else {
        if (current.length) {
          current[current.length - 1].childh3.push(headerEl);
        }
      }

      return current;
    }, []);

    settableContentMenu(structuredtoc);

    postEl.current.innerHTML = parentEl.innerHTML;
  }, [description]);

  // const [currentShown, setCurrentShown] = useState(-1);

  const [active, setActive] = useState(null);
  const navigateAction = (e, id) => {
    e?.preventDefault();

    const element = document.querySelector(`#${id}`);
    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;
    window.scrollTo(0, offsetPosition, { behavior: 'smooth' });
    
    setActive(id);
  };

  return (
    <section className={blogContStyle.blog__content}>
      <div className={blogContStyle.blog__content__container}>
        <div className={blogContStyle.table_of_data_section}>
          <aside className={blogContStyle.aside}>
            <h5>Table of Content</h5>
            <ul>
              {tableContentMenu.map((item, index) => (
                <li key={item.id}>
                  <span className={blogContStyle.tocRevealLinker}>
                    <a
                      href={`#${item.id}`}
                      onClick={(e) => navigateAction(e, item.id)}
                      className={active === item.id ? "active" : ""}
                    >
                      {item.innerText}
                    </a>
                  </span>

                  {item.childh3 && item.childh3.length > 0 && (
                    <ul>
                      {item.childh3.map((inner) => (
                        <li key={inner.id}>
                          <a
                            href={`#${inner.id}`}
                            onClick={(e) => navigateAction(e, inner.id)}
                            className={active === inner.id ? "active" : ""}
                          >
                            {inner.innerText}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            
            <BlogStickyBanner /> 

            <div className={blogContStyle.blog__social__share}>
              <ul className={blogContStyle.blog__social__icons}>
                <li className={`${blogContStyle.blog__social__item} ${blogContStyle.facebook}`}>
                  <a
                    className={blogContStyle.blog__social__link}
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${shareURl}`}
                    target="_blank"
                  >
                    <Facebook />
                  </a>
                </li>
                <li className={`${blogContStyle.blog__social__item} ${blogContStyle.twitter}`}>
                  <a
                    className={blogContStyle.blog__social__link}
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                    href={`https://twitter.com/intent/tweet?text=${shareURl}`}
                    target="_blank"
                  >
                    <Twitter />
                  </a>
                </li>
                <li className={`${blogContStyle.blog__social__item} ${blogContStyle.linkedIn}`}>
                  <a
                    className={blogContStyle.blog__social__link}
                    rel="noopener noreferrer"
                    aria-label="Linkedin"
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareURl}`}
                    target="_blank"
                  >
                    <LinkedIn />
                  </a>
                </li>
              </ul>
              <p>Share this article</p>
            </div>
          </aside>
          <article className={blogContStyle.article}>
            <div className={blogContStyle.blog_main_article} id="blog-content">
              <h1>{title}</h1>
              <div className={blogContStyle.blog__content__meta}>
                <div className={blogContStyle.blog__content__author}>
                  <span className={blogContStyle.blog__content__author__img}>
                    <img
                      src={authorImage.replace("http://", "https://")}
                      alt={author}
                    />
                  </span>
                  <span className={blogContStyle.blog__content__author__name}>
                    {author}
                  </span>
                </div>
                <ul className={blogContStyle.blog__content__meta__details}>
                  {readTime && (
                    <li>
                      Read Time: <span>{readTime}</span>
                    </li>
                  )}
                  {date !== updatedDate && (
                    <li>
                      Updated: <span>{updatedDate}</span>
                    </li>
                  )}
                  <li>
                    Published: <span>{date}</span>
                  </li>
                </ul>
              </div>

              {audioUrl && (
                <div className={blogContStyle.blog__content__audio}>
                  <ReactPlayer url={audioUrl} width="100%" height="auto" />
                </div>
              )}

              <div
                className={blogContStyle.blog__content__description}
                ref={postEl}
              />
            </div>
          </article>
        </div>
      </div>
      <div className={blogContStyle.recent_blog_section}>
        <div className={blogContStyle.recent_blog_container} id="recent-blog">
          <h2>Recent Articles</h2>
          <div className={blogContStyle.blogRow}>
            {recentBlogList.map((item, i) => (
              <BlogListing key={i} data={item} />
            ))}
          </div>
        </div>
      </div>
      <div className={blogContStyle.search_form}>
        <div className={blogContStyle.blog__content__container}>
          <div className={blogContStyle.blog_contact_section}>
            <div className={blogContStyle.research_content}>
              <h2>
                Looking for <span>UX/UI research</span>
              </h2>
              <h3>or product branding?</h3>
            </div>
            <form
              method="post"
              className={blogContStyle.formArea}
              id="blogDetailsForm"
              name="blogDetailsForm"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className={blogContStyle.emailArea}>
                <div
                  className={
                    errors.name
                      ? `${blogContStyle.formGroup} ${blogContStyle.error}`
                      : `${blogContStyle.formGroup}`
                  }
                >
                  <StaticImage
                    className={blogContStyle.envelope}
                    src="../../../images/user-icon.svg"
                    alt="user"
                    placeholder="blurred"
                  />
                  <input
                    type="text"
                    placeholder="Enter your name*"
                    autoComplete="name"
                    {...register("name")}
                  />
                </div>
                {errors.name && (
                  <span className={blogContStyle.errortxt}>
                    {errors.name.message}
                  </span>
                )}
              </div>

              <div className={blogContStyle.emailArea}>
                <div
                  className={
                    errors.email
                      ? `${blogContStyle.formGroup} ${blogContStyle.error}`
                      : `${blogContStyle.formGroup}`
                  }
                >
                  <StaticImage
                    className={blogContStyle.envelope}
                    src="../../../images/email-icon.svg"
                    alt="Envelope"
                    placeholder="blurred"
                  />
                  <input
                    type="email"
                    placeholder="Enter your email Id*"
                    autoComplete="email"
                    {...register("email")}
                  />
                  {errors.email || !getValues("email") ? (
                    ""
                  ) : (
                    <StaticImage
                      src="../../../images/fi-check-circle.png"
                      alt=""
                      width="15"
                      className={blogContStyle.verifiedemail}
                      placeholder="blurred"
                    />
                  )}
                </div>
                {errors.email && (
                  <span className={blogContStyle.errortxt}>
                    {errors.email.message}
                  </span>
                )}
              </div>
              <div className={blogContStyle.emailArea}>
                <div className={`${blogContStyle.formGroup}`}>
                  <StaticImage
                    className={blogContStyle.envelope}
                    src="../../../images/phone-icon.svg"
                    alt="Phone"
                    placeholder="blurred"
                  />
                  <input
                    type="tel"
                    placeholder="Phone number (optional)"
                    autoComplete="tel"
                    {...register("phone")}
                  />
                </div>
                {errors.phone && (
                  <span className={blogContStyle.errortxt}>
                    {errors.phone.message}
                  </span>
                )}
              </div>

              <div className={blogContStyle.emailArea}>
                <div
                  className={
                    errors.message
                      ? `${blogContStyle.formGroup} ${blogContStyle.error}`
                      : `${blogContStyle.formGroup}`
                  }
                >
                  <textarea
                    placeholder="Message*"
                    {...register("message")}
                  ></textarea>
                </div>
                {errors.message && (
                  <span className={blogContStyle.errortxt}>
                    {errors.message.message}
                  </span>
                )}
              </div>


              <button type="submit" disabled={apiLoading} style={{ cursor: `${apiLoading ? 'not-allowed' : 'pointer'}`}}>
                <span>There We Go!</span>
                {apiLoading && <Loader size={24} color="#fff" />}
                {!apiLoading && <GoArrowRight />}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
